import React from "react";

import ActionLink from "../../../components/admin/ActionLink";
import InfoCard from "../../../components/admin/InfoCard";
import PageIntro from "../../../components/admin/PageIntro";
import Pill from "../../../components/admin/Pill";
import SectionCard from "../../../components/admin/SectionCard";

export default function AiPlansAdminPage() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <PageIntro
        title="AI plans"
        description="Manage future AI-facing commercial and entitlement structures here. This area will support AI plan definitions, feature access, and later operational controls across the HnB platform."
      />

      <SectionCard
        eyebrow="Future AI module"
        title="AI plan management is ready for the next phase"
        description="Use this screen as the future workspace for AI pricing models, entitlement tiers, feature availability, and downstream controls once the AI module is introduced into the wider HnB architecture."
      >
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <Pill label="AI entitlements" />
          <Pill label="Feature access" />
          <Pill label="ERP expansion ready" />
        </div>
      </SectionCard>

      <section
        style={{
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "28px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "14px",
            background: "#eef2ff",
            color: "#4338ca",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
            fontWeight: 700,
          }}
        >
          A
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <h2 style={{ margin: 0, fontSize: "1.15rem", color: "#111827" }}>
            No AI plans yet
          </h2>

          <p style={{ margin: 0, color: "#6b7280", lineHeight: 1.6, maxWidth: "60ch" }}>
            AI pricing and entitlement records have not been added to the backend yet.
            Once the AI module is introduced, this page can support plan lists, access
            tiers, usage rules, and management workflows for AI-enabled HnB experiences.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <ActionLink
            to="/dashboard/platform-settings"
            label="Review platform settings"
          />
          <ActionLink
            to="/dashboard/provider-plans"
            label="Review provider plans"
          />
        </div>
      </section>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "16px",
        }}
      >
        <InfoCard
          title="Planned records"
          body="This module can later surface AI plan names, entitlement tiers, included features, and activation status."
        />
        <InfoCard
          title="Planned actions"
          body="Future actions can include plan creation, feature access updates, entitlement review, and lifecycle management."
        />
        <InfoCard
          title="Why it matters"
          body="A clear AI plan layer will help HnB control future monetization, access rules, and rollout structure for AI-enabled journeys."
        />
      </div>
    </div>
  );
}